import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/Button';
const slides = [{
  title: 'Hello, Mama',
  subtitle: "Aurora Care helps you monitor your baby's heartbeat every single day, wherever you are.",
  illustration: <svg viewBox="0 0 200 200" className="w-full h-full max-w-[280px] mx-auto" data-id="element-1247" data-mp="3qr8svf85lx7r">
        <circle cx="100" cy="100" r="80" fill="#F3E8FF" data-id="element-1248" data-mp="331eg0xnu48ni" />
        <path d="M100 40 C80 40, 70 60, 70 80 C70 110, 100 140, 100 140 C100 140, 130 110, 130 80 C130 60, 120 40, 100 40 Z" fill="#6B21E8" opacity="0.8" data-id="element-1249" data-mp="32ztkp5tp4lol" />
        <circle cx="100" cy="100" r="15" fill="#FFFFFF" className="animate-pulse" data-id="element-1250" data-mp="3cu2bnp32w6kn" />
        <path d="M95 100 L100 105 L110 95" stroke="#6B21E8" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round" data-id="element-1251" data-mp="2kb55n0hw9akq" />
      </svg>
}, {
  title: 'Wear & Forget',
  subtitle: 'Simply wear the Aurora Care belt and it silently monitors and records everything automatically.',
  illustration: <svg viewBox="0 0 200 200" className="w-full h-full max-w-[280px] mx-auto" data-id="element-1252" data-mp="x2zdtib2gkzp">
        <circle cx="100" cy="100" r="80" fill="#F3E8FF" data-id="element-1253" data-mp="115chm16968tu" />
        <rect x="40" y="85" width="120" height="30" rx="15" fill="#6B21E8" opacity="0.8" data-id="element-1254" data-mp="116xc5qskhrrp" />
        <circle cx="100" cy="100" r="20" fill="#FFFFFF" data-id="element-1255" data-mp="9ege3r631gj8" />
        <path d="M140 100 Q150 80 160 100 T180 100" stroke="#00D4D4" strokeWidth="4" fill="none" strokeLinecap="round" className="animate-pulse" data-id="element-1256" data-mp="df0cey2e6q6y" />
        <path d="M60 100 Q50 120 40 100 T20 100" stroke="#00D4D4" strokeWidth="4" fill="none" strokeLinecap="round" className="animate-pulse" data-id="element-1257" data-mp="1ovgmebv6gemf" />
      </svg>
}, {
  title: 'Always Connected',
  subtitle: 'Live data streams straight to your phone. Share reports with your doctor in seconds.',
  illustration: <svg viewBox="0 0 200 200" className="w-full h-full max-w-[280px] mx-auto" data-id="element-1258" data-mp="3pybsxhx1nt3">
        <circle cx="100" cy="100" r="80" fill="#F3E8FF" data-id="element-1259" data-mp="3ux13dq1o1w3u" />
        <rect x="70" y="50" width="60" height="100" rx="8" fill="#FFFFFF" stroke="#E9D5FF" strokeWidth="2" data-id="element-1260" data-mp="376etruc0k3rq" />
        <path d="M75 100 L85 100 L90 80 L100 120 L105 100 L125 100" stroke="#6B21E8" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round" data-id="element-1261" data-mp="3gw846s0f6cue" />
        <circle cx="100" cy="130" r="10" fill="#00D4D4" data-id="element-1262" data-mp="2of5j3hqib8yk" />
        <path d="M130 140 Q140 120 150 140" stroke="#2D2D2D" strokeWidth="3" fill="none" strokeLinecap="round" data-id="element-1263" data-mp="2oduifqscyhbo" />
        <circle cx="140" cy="115" r="8" fill="#2D2D2D" data-id="element-1264" data-mp="yx8nvj0x68pn" />
      </svg>
}];
export function IntroSlides() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [direction, setDirection] = useState<'left' | 'right'>('right');
  const navigate = useNavigate();
  const touchStartX = useRef<number | null>(null);
  const nextSlide = () => {
    if (currentSlide === slides.length - 1) {
      navigate('/register');
    } else {
      setDirection('right');
      setCurrentSlide(prev => prev + 1);
    }
  };
  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
  };
  const handleTouchEnd = (e: React.TouchEvent) => {
    if (touchStartX.current === null) return;
    const touchEndX = e.changedTouches[0].clientX;
    const diff = touchStartX.current - touchEndX;
    if (diff > 50) {
      nextSlide();
    } else if (diff < -50 && currentSlide > 0) {
      setDirection('left');
      setCurrentSlide(prev => prev - 1);
    }
    touchStartX.current = null;
  };
  return <div className="min-h-screen w-full bg-background flex flex-col items-center justify-between p-6 animate-fadeInUp md:bg-secondary md:justify-center" data-id="element-1265" data-mp="hk8ywiazaq3d">
      <div className="w-full max-w-[480px] h-full min-h-[100dvh] md:min-h-[600px] md:h-[80vh] bg-background md:rounded-card md:shadow-elevated flex flex-col relative overflow-hidden" data-id="element-1266" data-mp="7tedfg5k3uiz">
        {/* Progress Pills */}
        <div className="flex justify-center space-x-2 pt-12 pb-8 z-10" data-id="element-1267" data-mp="10gibt2a59als">
          {slides.map((_, idx) => <div key={idx} className={`h-2 rounded-pill transition-all duration-300 ${idx === currentSlide ? 'w-6 bg-primary' : 'w-2 bg-border'}`} data-id="element-1268" data-mp="viqka9devqi4" data-mpi={idx} />)}
        </div>

        {/* Slides Container */}
        <div className="flex-1 relative w-full" onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd} data-id="element-1269" data-mp="3c746s93uwcyx">
          {slides.map((slide, idx) => <div key={idx} className={`absolute inset-0 flex flex-col items-center transition-transform duration-300 ease-in-out ${idx === currentSlide ? 'translate-x-0 opacity-100' : idx < currentSlide ? '-translate-x-full opacity-0' : 'translate-x-full opacity-0'}`} data-id="element-1270" data-mp="1mpph5xmtn3al" data-mpi={idx}>
              <div className="w-full h-[40%] flex items-center justify-center mb-8" data-id="element-1271" data-mp="20hdshyp8xnqi">
                {slide.illustration}
              </div>
              <div className="px-8 text-center" data-id="element-1272" data-mp="25fp0e3vzdo63">
                <h2 className="text-[26px] font-semibold text-text-primary mb-3" data-id="element-1273" data-mp="2aeif1zn07l7u">
                  {slide.title}
                </h2>
                <p className="text-[16px] text-text-secondary max-w-[280px] mx-auto leading-relaxed" data-id="element-1274" data-mp="2fffuw5kjk366">
                  {slide.subtitle}
                </p>
              </div>
            </div>)}
        </div>

        {/* Bottom Actions */}
        <div className="p-6 pb-12 w-full flex flex-col items-center z-10 bg-background" data-id="element-1275" data-mp="p1p02rt83wib">
          <Button onClick={nextSlide} className="max-w-[320px]" data-id="element-1276" data-mp="p3i92drb6sth">
            {currentSlide === slides.length - 1 ? 'Get Started' : 'Next'}
          </Button>
          <button onClick={() => navigate('/login')} className="mt-6 text-primary font-medium text-[14px] hover:opacity-80 transition-opacity" data-id="element-1277" data-mp="1net7w5p4bihh">
            Already have an account? Sign in
          </button>
        </div>
      </div>
    </div>;
}